module.exports = __webpack_public_path__ + "static/media/folder.94d7aa52.svg";